var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0c55.23 0 100 44.773 100 100S155.224 200 99.997 200C44.773 200 0 155.227 0 100S44.773 0 100 0Zm63.489 108.316H36.51c0 36.4 28.424 65.91 63.486 65.91 35.065 0 63.492-29.51 63.492-65.91Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    fill: "#FFF",
    d: "M27.15 62.057h146.738v61.41H27.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.197 78.245c-7.608 0-13.77 6.163-13.77 13.77 0 7.605 6.164 13.772 13.77 13.772 7.603 0 13.768-6.168 13.768-13.773 0-7.604-6.167-13.769-13.768-13.769Zm92.78 30.435c-1.244-13.136-4.389-36.548-6.305-43.426a28.474 28.474 0 0 0-1.107-3.238c-2.548-6.243-7.066-10.177-15.519-12.396-9.334-2.446-22.318-7.602-69.85-7.602s-60.517 5.156-69.843 7.602C21.9 51.84 17.38 55.773 14.83 62.016a29.49 29.49 0 0 0-1.106 3.238C11.8 72.132 8.66 95.544 7.417 108.68c-.234 2.446-.399 4.538-.479 6.096-.508 9.931 1.687 14.17 8.08 18.419 4.164 2.765 7.996 5.323 14.79 8.484 6.795 3.157 15.093 6.998 24.209 6.998 5.698 0 24.46-3.78 31.366-4.951 4.492-.762 10.551-1.192 14.813-1.192 4.261 0 10.32.43 14.814 1.192 6.906 1.172 25.668 4.951 31.366 4.951 9.116 0 17.414-3.841 24.208-6.998 6.793-3.16 10.628-5.72 14.784-8.484 6.397-4.25 8.59-8.488 8.085-18.419-.08-1.561-.245-3.65-.477-6.096Zm-92.78 5.628c-21.728 0-39.999-22.294-39.999-22.294 0-1.206 18.27-22.293 40-22.293 21.726 0 39.993 22.293 39.993 22.293s-18.267 22.294-39.994 22.294Z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bc806dd3363c2b3fa24bea1e72a60695.svg";
export { ForwardRef as ReactComponent };